import { render, staticRenderFns } from "./HeaderNextMobileButtons.vue?vue&type=template&id=08d57816&scoped=true&"
import script from "./HeaderNextMobileButtons.vue?vue&type=script&lang=ts&"
export * from "./HeaderNextMobileButtons.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNextMobileButtons.vue?vue&type=style&index=0&id=08d57816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d57816",
  null
  
)

export default component.exports